var $$ = $$ || {};

$$.ProductCards = class ProductCards {
	constructor (root) {
		this.root = root;

		this._cacheNodes();
		this._bindEvents();
		this._ready();
	}

	_cacheNodes () {
		this.nodes = {
			wrapper: this.root.find('.js-inner'),
			items: this.root.find('.js-item'),
			progressBar: this.root.find('.js-progress-wrapper')
		};
	}


	_bindEvents () {
		$$.window.on('resize', _.debounce(() => {
			this._hideShowCards();
		}, 200));
	}

	_ready () {
		this._hideShowCards();

		this.nodes.progressBar.addClass('not-hover');

	}

	_hideShowCards () {
		var wrapperWidth = this.nodes.wrapper.width();
		var itemWidth = this.nodes.items.innerWidth();
		var fitItems = parseInt(wrapperWidth / itemWidth);
		var itemsLength = this.nodes.items.length;

		( fitItems < 4 ? fitItems = 4 : null )

		this.nodes.progressBar.width( itemsLength * itemWidth + 1 );

		this.nodes.items.each((index, event) => {
			if ( index >= fitItems ) {
				$(event).hide();
			} else {
				$(event).show();
			}
		});
	}
};
